const columns = [
  {
    text: 'ID',
    align: 'start',
    sortable: true,
    cell: 'TextCell',
    columnName: 'id',
    width: 70,
    displaySize:'lgAndUp', //all | mdAndDown | lgAndUp
  },{
    text: 'Kopie',
    align: 'start',
    sortable: true,
    cell: 'TextCell',
    columnName: 'clone',
    width: 140,
    displaySize:'lgAndUp', //all | mdAndDown | lgAndUp
  },

  {
    text: 'BE-Mitarbeitende',
    align: 'start',
    sortable: true,
    cell: 'Zueri9VbzNr',
    columnName: 'zueri9VbzNr',
    width:200,
    displaySize:'lgAndUp', //all | mdAndDown | lgAndUp
  },
  {
    text: 'BE-Mitarbeitende',
    align: 'start',
    sortable: true,
    cell: 'Zueri9VbzNr',
    columnName: 'zueri9VbzNr',
    width:140,
    displaySize:'mdAndDown', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Dienst',
    align: 'start',
    sortable: true,
    cell: 'DutyCellWithDetailView',
    columnName: 'z9Duty',
    width:100,
    displaySize:'lgAndUp', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Dienst von - bis',
    align: 'center',
    sortable: true,
    cell:'FromTo',
    columnName: 'z9FromTo',
    width:200,
    displaySize:'lgAndUp', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Dienst, Linie/Kurs<br>Dienst von - bis',
    align: 'start',
    sortable: true,
    cell:'DutyLineTrackZ9',
    columnName: 'z9FromToTwoLines',
    width:210,
    displaySize:'mdAndDown', //all | mdAndDown | lgAndUp
  },

  {
    text: 'Linie/Kurs',
    align: 'start',
    sortable: false,
    cell:'TextCell',
    columnName: 'z9Line',
    width:80,
    displaySize:'lgAndUp', //all | mdAndDown | lgAndUp
  },

  {
    text: 'Für wen<br>Was',
    cell:'Zueri9ClientAndReason',
    columnName: 'zueri9ClientAndReason',
    sortable: true,
    align: 'start',
    width:120,
    displaySize:'mdAndDown', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Für wen',
    cell:'Zueri9Clients',
    columnName: 'zueri9Client',
    sortable: true,
    align: 'start',
    width:100,
    displaySize:'lgAndUp', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Was',
    cell:'Zueri9Reason',
    columnName: 'zueri9Reason',
    sortable: true,
    align: 'start',
    width:100,
    displaySize:'lgAndUp', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Bemerkung',
    cell:'MultiLineTextCell',
    columnName: 'remarks',
    sortable: true,
    align: 'start',
    displaySize:'all', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Status',
    align: 'center',
    sortable: true,
    cell:'Zueri9State',
    columnName: 'zueri9State',
    width:130,
    displaySize:'lgAndUp', //all | mdAndDown | lgAndUp
  },

  {
    text: 'Änderung am',
    align: 'center',
    sortable: true,
    cell:'LastModified',
    columnName: 'lastModified',
    width:120,
    displaySize:'lgAndUp', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Status, Änderung am / durch',
    align: 'center',
    sortable: true,
    cell:'LastModified',
    columnName: 'lastModified',
    width:130,
    displaySize:'mdAndDown', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Änderung durch',
    align: 'start',
    sortable: false,
    cell:'TextCell',
    columnName: 'disponent',
    width:80,
    displaySize:'lgAndUp', //all | mdAndDown | lgAndUp
  },
  {
    text: 'Aktionen',
    cell:'actions',
    columnName: 'actions',
    sortable: false,
    align: 'center',
    width:100,
    displaySize:'all', //all | mdAndDown | lgAndUp
  },

  // { text: '', columnName: 'data-table-expand' },
];
export default columns;
